import { styled } from '@mui/material'
import MuiDialogContent from '@mui/material/DialogContent'
import React from 'react'

import Dialog, { DialogProps } from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'
import { TWhatsappFlowContent, TWhatsappFlowPage } from '@/app/types'

import WhatsappFlowContent from './whatsapp-flow-content'

type Props = Omit<DialogProps, 'content' | 'onClose'> & {
  content: TWhatsappFlowContent

  onClose: () => void
}

const DEFAULT_TITLE = 'WhatsApp Form'

const WhatsappFlowDialog: React.FC<Props> = ({ content, onClose, ...props }) => {
  const [title, setTitle] = React.useState(DEFAULT_TITLE)

  const handlePageChange = React.useCallback((page?: TWhatsappFlowPage) => {
    setTitle(page?.title || DEFAULT_TITLE)
  }, [])

  return (
    <Dialog {...props} fullWidth maxWidth="sm">
      <DialogHeader title={title} onClose={onClose} />
      <DialogContent>
        <WhatsappFlowContent content={content} onPageChange={handlePageChange} />
      </DialogContent>
    </Dialog>
  )
}

const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  paddingTop: `${theme.spacing(3)} !important`,
}))

export default WhatsappFlowDialog
